export enum PhoneValidationStep {
  EnterPhoneNumber,
  ValidatePhoneNumber,
}
